import React, { Component } from 'react';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import PlatformName from '../../components/platformName/index.jsx';
import '../../assets/css/common.less';
import './index.less';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, isNotNull, getPlatformName, messageShow, matchSupplierProduct, systemConfig, getZkShopName, getTaoteShopName } from '../../utils/http';
import { MatchTaoteLinkRequest } from '../../utils/api';
import { Dialog, Input, Select, Tabs, Button, Pagination, Checkbox, Radio, Message, Steps, Progress,MessageBox} from 'element-react';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import $ from 'jquery';
import ShowModal from '../../components/showModal/index.jsx';
import ChangeProductsModule from '../../components/changeProductsModule/index.jsx';
import NewUserGuide from '../../components/newUserGuide/index.jsx';

import { GetProductImageTextListRequest,GetTouTiaoBgmListRequest,PlatformUploadImageRequest,SaveProductImageTextRequest,ApplyProductImageTextRequest,ProductImageTextDetailRequest,ImageTextShopAccessThresholdRequest } from '../../utils/api';



class ProductImageText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageSize: 10,
            current: 1,
            total: 0,
            isLoading:false,//是否加载
            //---------------店铺信息-------------------------
            currentShopId:0,
            currentPlatformType:'',
            currentShopName:'',
            productImageTextList:[],//列表
            //编辑功能
            productImageText:{
                BgmId: "",
                MaterialId: "",
                Name: "",
                PicUrls: [],
                ProductId: "",
                SubTitle: "",
                IsApply:false,
            },
            
            //--------------------页面功能展示相关-------------------------
            productStatus: [{ value: "", label: "商品状态" }, { value: "published", label: "在售" }, { value: "nopublished", label: "下架" }],
            processStatus: [
                { value: "", label: "商品图文状态" }, 
                { value: "0", label: "未发布" }, 
                { value: "1", label: "发布中" },
                { value: "2", label: "发布成功" },
                { value: "3", label: "发布失败" },
            ],
            selectProductStatus:'published',//商品状态
            selectProcessStatus:'',//图文发布状态
            searchType:'ProductID',//搜索类型

            //----------------背景音乐
            bgmList:[],
            selectedBgmUrl:'',

            isShowReleaseDailog: false,
            isShowAddImageBtn:true,
            imageItems:[],
            bigImageSrc:''
        };
    }

    componentDidMount(props) { //组件挂载到DOM渲染后被执行，只会执行一次。
        //this.loadShopList();
        
        var zhukeToken = getToken();
        var that = this;
        if (zhukeToken != "")
        {
            that.loadData();
        }
        else {
            setTimeout(() => {
                var zhukeTokenTwo = getToken();
                if (zhukeTokenTwo == "") {
                    var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
                    //var hasZhukeLoginShopTokens = "";//测试。
                    if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
                        loadZhuKeToken(hasZhukeLoginShopTokens);

                        setTimeout(() => {
                            var zhukeTokenThree = getToken();
                            if (zhukeTokenThree != "")
                                that.loadData();
                            else
                                that.setState({ isShowWarn: true });

                        }, 500);
                    } else
                        that.setState({ isShowWarn: true });
                } else{
                    that.loadData();
                }
            }, 500);

        }
    }
    async getTouTiaoBgmList(){
        const res = await GetTouTiaoBgmListRequest();
        if(res.Success){
            let dataJson = res.Data || '[]'
            try{
                console.log('bgmList =>',bgmList)
                let bgmList = JSON.parse(dataJson);
                this.state.bgmList = bgmList.map(x => {
                    x.label = x.music_name
                    x.value = x.music_id
                    return x;
                });
                
                this.setState({ })
            }catch(e){
            }
        }
    }
    loadData = () => {
        var shopInfo = getLoginShopInfo();
        var that = this;
        this.state.shopList = [{
            Id:shopInfo.loginShopId,
            ShopName:shopInfo.loginShopName,
            PlatformType:shopInfo.loginShopPlatformType,
            IsChecked:true,
            AuthUrl:'',
            PayUrl:''
        }];
        this.state.currentShopId = shopInfo.loginShopId
        this.state.currentPlatformType = shopInfo.loginShopPlatformType
        this.state.currentShopName = shopInfo.loginShopName
        this.setState({ },()=>{
            this.imageTextShopAccessThreshold();
            this.queryButton()
            this.getTouTiaoBgmList()
        })
    }

    loadList = async () => {

        let data = {
            PageIndex:this.state.current,
            PageSize:this.state.pageSize,
            ShopId:this.state.currentShopId,
            PlatformType:this.state.currentPlatformType,
            ProductStatus:this.state.selectProductStatus,
            ImageTextStatus:this.state.selectProcessStatus,
        }
        let keyword = $("#productTitle").val();
        
        if(this.state.searchType == 'ProductID')
        {
            data.ProductId = keyword;
        }
        else if(this.state.searchType == 'ProductSubject')
        {
            data.ProductTitle = keyword;
        }
        this.setState({ isLoading: true })
        const res = await GetProductImageTextListRequest(data)
        this.setState({ isLoading: false })
        if (res.Success == true) {
            this.state.productImageTextList = (res.Data && res.Data.List) || [];
            this.state.total = (res.Data && res.Data.Total) || 0
            this.setState({ })
        }else{

        }
    }

    queryButton = () => {
        this.state.current = 1;
        this.loadList();
    }

    changeCurrent = (current) => {
        this.setState({
            current,
            checkAll: false
        }, () => {
            this.loadList();
        })
    }
    changePageSize = (size) => {
        this.setState({
            pageSize: size,
            current: 1,
        }, () => {
            this.loadList();
        })
    }
    changeSelect = (name, value) => {
        this.setState({
          [name]: value
        })
    }
    gotoRelease = () => {

    }
    closeReleaseDailog = () => {
        this.state.productImageText = { };
        this.state.selectedBgmUrl = '';
        this.setState({ isShowReleaseDailog: false,imageItems:[], isShowAddImageBtn:true,bigImageSrc:''})
    }
    selectBgm(value){
        this.state.productImageText.BgmId = value
        const bgm = this.state.bgmList.find(x => x.music_id == value);
        this.state.selectedBgmUrl = bgm.url
        this.setState({ selectedBgmUrl:bgm.url },()=>{
            this.refs.background_bmg.load();
        })
    }
    showReleaseDailog = async (item) => {
        this.setState({ isLoading : true})
        if(item.ProductImageText)//编辑
        {
            this.state.productImageText.BgmId = item.ProductImageText.BgmId
            this.state.productImageText.MaterialId = item.ProductImageText.MaterialId
            this.state.productImageText.Name = item.ProductImageText.Name
            this.state.productImageText.ProductId = item.ProductImageText.ProductId
            this.state.productImageText.SubTitle = item.ProductImageText.SubTitle

            var index = 0
            item.ProductImageText.PicUrls.split(',').map(x => {
                this.state.imageItems.push({
                    Id:'pic'+'_'+Math.ceil(Math.random()*1000000),
                    ImageUrl:x,
                    url:x,
                    sort:index
                })
                index++;
            })
        }else{ //新增
            const res = await this.productImageTextDetail(item.Product.PlatformId);
            if(!res.Success){
                this.setState({ isLoading : false})
                messageShow(res.Message,'error');
                return;
            }
            
            this.state.productImageText.ProductId = item.Product.PlatformId
            this.state.productImageText.SubTitle = ''

            var index = 0

            let images = (res.Data && res.Data.ProductBasic && res.Data.ProductBasic.PicList) || item.Product.ImageUrl.split(',');
            images.map(x => {
                this.state.imageItems.push({
                    Id:'pic'+'_'+Math.ceil(Math.random()*1000000),
                    ImageUrl:x,
                    sort:index,
                    url:x,
                })
                index++;
            })
        }
        if(this.state.bgmList && this.state.bgmList.length > 0 && this.state.productImageText.BgmId ){
            var bgmItem = this.state.bgmList.find(x => this.state.productImageText.BgmId == x.music_id)
            if(bgmItem) this.state.selectedBgmUrl = bgmItem.url
        }
        if(this.state.imageItems.length > 0){
            this.state.bigImageSrc = this.state.imageItems[0].ImageUrl;
            if (this.state.imageItems.length >= 5) {
                this.state.isShowAddImageBtn = false;
            }
        }
        this.setState({ isShowReleaseDailog: true,isLoading:false })
    }
    addProductPic=()=>{
        if (this.state.imageItems.length >= 5) {
            messageShow('最多只能添加五张图片','info');
            return;
        }
        document.getElementById("productPic").click();
    }
    changeProductPic=()=>{
        // var e=event || window.event;
        let imageItems=this.state.imageItems;

        var selectedPicFiles = document.getElementById('productPic').files; //获取所有选中的文件
        selectedPicFiles = [selectedPicFiles[0]] //只拿一个图片，暂时不弄批量上传
        // if (selectedPicFiles.length > 5 || imageItems.length + selectedPicFiles.length > 5) { //所选择的图片不要超过5张
        //     Message({
        //         showClose: true,
        //         message: '不要超过5张',
        //         type: 'error'
        //       });
        //     return;
        // }
        if (imageItems.length + selectedPicFiles.length < 5) {
            this.setState({isShowAddImageBtn:true})
        } else {
            this.setState({isShowAddImageBtn:false})
        }

        var promiseSelectPicArry = []; //解决异步任务  Promise.all调用
        var maxSort = imageItems.length ? imageItems[imageItems.length - 1].sort + 1 : 0; //取产品图片数组 序号最大的值		

        for (var i = 0; i < selectedPicFiles.length; i++) {
            if (!this.checkFileExt(selectedPicFiles[i].name, ["jpg", "png", "gif"])) {
                Message({
                    showClose: true,
                    message: '文件格式不对,jpg,png,gif',
                    type: 'error'
                  });
                return;
            }
            var size = (selectedPicFiles[i].size / 1024).toFixed(2)
            if (size > 1000) { //大于1m不上传 1000000
                Message({
                    showClose: true,
                    message: '文件大小不能大于1M',
                    type: 'error'
                  });
                return;
            }
            var p = new Promise((resolve, reject) => { //用Promise 有异步任务 load				
                var fileRead = new FileReader(); //      新建一个文件对象 读取文件信息  主要作显示用的 把flies图片转为base64位
                fileRead.readAsDataURL(selectedPicFiles[i]);
                var picName = selectedPicFiles[i].name;
                var $sort = maxSort + i;
                fileRead.addEventListener("load", function() {
                    var param = {};
                    var imgBase64 = this.result;
                    param.Id = 'pic'+'_'+Math.ceil(Math.random()*1000000);
                    param.FileName = picName;
                    param.ImageUrl = imgBase64;
                    param.sort = $sort; //用于排序
                    resolve(param);
                })
            })
            promiseSelectPicArry.push(p)
        }
        this.setState({ isLoading: true})
        Promise.all(promiseSelectPicArry).then(async (resultData)=> {
            try{
                for (let index = 0; index < resultData.length; index++) {
                    const element = resultData[index];
                    const res = await this.platformUploadImage(element.ImageUrl);
                    if(res){
                        this.state.folderId =  res.FolderId
                        element.MaterialId = res.MaterialId;
                        imageItems.push(element);
                        this.setState({imageItems:imageItems})
                    }
                    else{
                        messageShow('上传图片失败')
                    }
                }
                resultData.forEach(element => {
                    
                });
            }catch(e){
                console.log(e)
            }
            this.setState({ isLoading: false})
        })	
    }

    productImageTextDetail(productId){
        let data ={
            ShopId:this.state.currentShopId,
            PlatformType:this.state.currentPlatformType,
            ProductId:productId,
        }
        return ProductImageTextDetailRequest(data);
    }
    async platformUploadImage(base64){
        let data ={
            TargetPlatformType :this.state.currentPlatformType,
            TargetShopId:this.state.currentShopId,
            FolderId : this.state.folderId,
            ImgBase64:base64
        }
        const res = await PlatformUploadImageRequest(data);
        if(res.Success){
            return res.Data
        }
        return null;
    }
    checkFileExt=(fileName, arr, isGetExt)=>{
        var flag = false;
        var $arr = arr;
        var index = fileName.lastIndexOf(".");//返回 . 所在的索引号
        var ext = fileName.substr(index + 1);//获取文件扩展名
        if (isGetExt) {
            return ext;
        }
        for (var i = 0; i < $arr.length; i++) {
            if (ext == arr[i]) {
                flag = true;//一旦找到合适的，立即退出循环
                break;
            }
        }
        return flag;

    }

    delProductPic = (id,e)=> { //删除商品主图图片
        e.stopPropagation();
        let imageItems=this.state.imageItems;
        for (var i = 0; i < imageItems.length; i++) {
            if (imageItems[i].Id == id) {
                imageItems.splice(i, 1);
                break;
            }
        }     
        this.setState({imageItems})
        if(imageItems.length<5){
            this.setState({isShowAddImageBtn:true})
        }
    }

    moveImageItem=(index,isLeft,e)=>{
        e.stopPropagation();
        let imageItems=this.state.imageItems;
        if(index==0 && isLeft){
            return;
        }
        if(!isLeft && imageItems.length-1==index){
            return;      
        }
        let selectObj=imageItems[index];
        let targetObj=[];
        if(isLeft){
            targetObj=imageItems[index-1];
            imageItems[index]=targetObj;
            imageItems[index-1]=selectObj;
        }else{
            targetObj=imageItems[index+1];
            imageItems[index]=targetObj;
            imageItems[index+1]=selectObj;
        }
 
        this.setState({imageItems:imageItems})
    }
    showBigPic=(id)=>{
        let imageItems=this.state.imageItems;
        imageItems.forEach((item)=>{
            if(item.Id==id){
                this.setState({bigImageSrc:item.ImageUrl})
            }
        })
    }
    
    deItem=()=>{
        MessageBox.confirm('视频删除后，将不再抖音推荐feed呈现，可能会影响到商品转化效果，请谨慎操作!', '确认删除视频?', {
            type: 'warning'
          }).then(() => {
    
          }).catch(() => {
 
          });
    }
    async saveProductImageText(isApply){
        let subTitle = this.state.productImageText.SubTitle
        let bgmId = this.state.productImageText.BgmId
        let productId = this.state.productImageText.ProductId
        let materialId = this.state.productImageText.MaterialId
        if(!bgmId)
        {
            messageShow('请选择背景音乐','info')
            return;
        }
        if(!subTitle){
            messageShow('请输入图文标题','info')
            return
        }
        let images = this.state.imageItems || [];
        let picUrls = [];
        console.log('images =>',images);
        images.forEach(item => {
            if(item.MaterialId){
                picUrls.push({
                    MaterialId:item.MaterialId,
                    Url:''
                })
            }else{
                picUrls.push({
                    MaterialId:'',
                    Url:item.url
                })
            }
        });
        if(picUrls.length == 0){
            messageShow('请上传图片','info')
            return
        }

        let data ={
            BgmId :bgmId,
            ProductId:productId,
            SubTitle :subTitle,
            MaterialId:materialId,
            ShopId : this.state.currentShopId,
            PlatformType : this.state.currentPlatformType,
            IsApply:isApply,
            PicUrlList:picUrls,
        };
        this.setState({ isLoading : true})
        const res = await SaveProductImageTextRequest(data)
        this.setState({ isLoading : false})
        if(res.Success){
            //保存成功
            messageShow('保存成功','success')
            this.closeReleaseDailog();
            setTimeout(()=>{
                this.queryButton();
            },800)
        }else{
            messageShow(res.Message,'error')
        }
    }
    async confirmApply(item){
        await MessageBox.confirm("是否确定发布");
        console.log('item =>',item);
        let data = {
            ShopId:this.state.currentShopId,
            PlatformType :this.state.currentPlatformType,
            MaterialId : item.ProductImageText.MaterialId
        }
        const res = await ApplyProductImageTextRequest(data);
        if(res.Success){
            messageShow('保存成功,请等待审核','success')
            setTimeout(()=>{
                this.queryButton();
            },800)
        }else{
            messageShow(res.Message,'error')
        }
    }
    copyText=(text)=>{
        var textareaC = document.createElement('textarea');
        textareaC.setAttribute('readonly', 'readonly'); //设置只读属性防止手机上弹出软键盘
        textareaC.value = text;
        document.body.appendChild(textareaC); //将textarea添加为body子元素
        textareaC.select();
        var res = document.execCommand('copy');
        document.body.removeChild(textareaC);//移除DOM元素
        messageShow('复制成功','info')
    }

    showReleaseProductDailog = () => {

        return (
            <div className='releaseProductDailog'>
                <div className="releaseProductDailog-main">
                    <div className='releaseProductDailog-title'>
                        <span className='releaseProductDailog-title-left'>发布商品图文</span>
                        <span className='iconfont icon-jia-copy1' onClick={() => this.closeReleaseDailog()}></span>
                    </div>
                    <div className='releaseProductDailog-content'>
                        <div className="releaseProductDailog-content-left">

                            <ul className='releaseProductDailog-content-ul'>
                                <li className='releaseProductDailog-content-li'>
                                    <div className='releaseProductDailog-content-title'><i>*</i>图文标题</div>
                                    <div className='releaseProductDailog-content-main'>
                                        <Input
                                            type="textarea"
                                            autosize={{ minRows: 2, maxRows: 4 }}
                                            placeholder="请输入"
                                            maxLength='120'
                                            defaultValue={ this.state.productImageText.SubTitle}
                                            onChange={(value)=>{ 
                                                this.state.productImageText.SubTitle = value;
                                            }}
                                        />
                                    </div>
                                    <div className='releaseProductDailog-content-warn'>
                                        <span>示例：男孩们，这款T恤真的太好看了！宽松的版型，舒适透气的面料，还有时尚的潮牌元素，简直是夏季必备单品！搭配牛仔裤或运动裤，秒变潮流男神！</span>
                                        {/* <span className='defColor hover' onClick={()=>{ this.copyText('12312')}}>复制</span> */}
                                        <span> #话题1 #话题2</span>
                                    </div>
                                </li>
                                <li className='releaseProductDailog-content-li'>
                                    <div className='releaseProductDailog-content-title'><i>*</i>背景音乐</div>
                                    <div className='releaseProductDailog-content-main' style={{ alignItems: 'center' }}>
                                        <Select value={this.state.productImageText.BgmId} onChange={(value)=>{ this.selectBgm(value)}}  >
                                            {
                                                this.state.bgmList.map((el) => {
                                                    return <Select.Option key={el.value} label={el.label} value={el.value} style={{width:'200px'}} />
                                                })
                                            }
                                        </Select>
                                        {
                                            this.state.selectedBgmUrl ?
                                            <audio id='background_bmg' ref={'background_bmg'} loop controls style={{marginLeft:'10px',height:'40px'}}>
                                                <source src={this.state.selectedBgmUrl} type="audio/mpeg"/>
                                            </audio>:null
                                        }
                                    </div>

                                </li>
                                <li className='releaseProductDailog-content-li'>
                                    <div className='releaseProductDailog-content-title'><i>*</i>图片信息</div>
                                    <div className='releaseProductDailog-content-main'>
                                        <div class="productPicWrap">
                                            <div class="productPicShow" id="productPicShow">
                                            {
                                                this.state.imageItems.map((item,index) =>
                                                <div class="productPic-list" onClick={()=>this.showBigPic(item.Id)}>
                                                    <img src={item.ImageUrl}></img>
                                                    <div class="productPic-list-operate">
                                                        <span class="productPic-list-operate-item" onClick={(e)=>this.moveImageItem(index,true,e)}>
                                                            <i className='iconfont icon-xiayi'></i>
                                                            <s>左移</s>
                                                        </span>
                                                        <span class="productPic-list-operate-item" onClick={(e)=>this.delProductPic(item.Id,e)}>
                                                            <i className='iconfont icon-31shanchu'></i>
                                                            <s>删除</s>
                                                        </span>
                                                        <span class="productPic-list-operate-item" onClick={(e)=>this.moveImageItem(index,false,e)}>
                                                            <i className='iconfont icon-xiayi' style={{transform: 'rotate(270deg)'}}></i>
                                                            <s>右移</s>
                                                        </span>
                                                    </div>

                                                </div>
                                                )
                                            }
                                            </div>
                                            {
                                                this.state.isShowAddImageBtn?
                                                <span id="addProductPicBtn" class="iconfont icon-tubiaolunkuo- icon-tubiaolunkuo-active" onClick={()=>this.addProductPic()}>
                                                    <span style={{fontSize:'12px'}}>本地上传</span>
                                                </span>:
                                                <span id="addProductPicBtn" class="iconfont icon-tubiaolunkuo-"  onClick={()=>this.addProductPic()}>
                                                    <span style={{fontSize:'12px'}}>本地上传</span>
                                                </span>
                                            }

                                            <input multiple type="file" name="productPic" id="productPic" onChange={()=>this.changeProductPic()} />                                     
                                        </div>
                                    </div>

                                </li>
                            </ul>

                        </div>
                        <div className="releaseProductDailog-content-right">
                            <img src={this.state.bigImageSrc} alt="" />
                        </div>
                    </div>

                    <div className='releaseProductDailog-footer'>
                        <Button onClick={() => this.closeReleaseDailog()}>取消</Button>
                        <Button style={{borderColor:"#3894ff",color:"#3894ff"}} onClick={()=>{ this.saveProductImageText(false)}}>仅保存</Button>
                        <Button type="primary" onClick={()=>{ this.saveProductImageText(true)}}>保存并发布</Button>

                    </div>

                </div>

            </div>
        )
    }
    async imageTextShopAccessThreshold(){
        let data = { ShopId : this.state.currentShopId }
        const res = await ImageTextShopAccessThresholdRequest(data)
        if(!res.Success){
            return;
        }
        const key = 'toutiao_product_image_text_invalid_alert';
        let previousTime = localStorage.getItem(key);
        const now = new Date().valueOf();

        if(!previousTime || (parseInt(previousTime) + 86400000) < now){
            localStorage.setItem(key,now);

            await MessageBox.confirm(
            <div>
                <div>
                    抖店官方规定：商品图文制作需要开通以下权限
                </div>
                <div style={{marginTop:'10px'}}>
                    <div><span>*绑定人店一体账号</span></div>
                    <div style={{marginTop:'10px'}}><span>*电商带货权限</span></div>
                </div>
            </div>, 
              '暂无商品图文发布权限', {
                customClass: 'home_reach_listing_count_dailog',
                confirmButtonText: "前往商家后台"
            });
            window.open('https://fxg.jinritemai.com/ffa/creative/graphics-position-middle');
            
        }
    }

    render() {
        return (
            <div className='wrap'>
                <HeaderMenu />
                <main>
                    <div className='wrap-left scroll-x' >
                        <NavMenu changeNav={this.changeLeftNav} defaultActive={"/orderList"} />
                    </div>
                    <div className="wrap-right productImageTextWrap">
                        <div className='productImageTextWrap-warn'>
                            <i>!</i>
                            <span>想要商品曝光机会暴增!24h自然流量不间断!快来使用商品图文，内容创作更简单!不占用短视频挂车额度，全部都是额外收益</span>
                            <a className='dColor hover ml5' href="https://school.jinritemai.com/doudian/web/article/aHrXQUSMx9Qk?btm_ppre=a4977.b5856.c0.d0&btm_pre=a4977.b7658.c0.d0&btm_show_id=14fae130-f900-4f0c-8132-37b70918f035" target='_blank'>查看详情</a>
                        </div>

                        <div className='searchWrap mywrap' style={{ marginTop: '15px' }}>
                            <label className='selectWrap'>
                                <Select value={this.state.selectProductStatus} onChange={this.changeSelect.bind(this, "selectProductStatus")} >
                                {
                                    this.state.productStatus.map((el) => {
                                        return <Select.Option key={el.value} label={el.label} value={el.value} />
                                    })
                                }
                                </Select>
                            </label>
                            <label className='selectWrap' >
                                <Select value='' onChange={this.changeSelect.bind(this, "selectProcessStatus")} >
                                {
                                    this.state.processStatus.map((el) => {
                                        return <Select.Option key={el.value} label={el.label} value={el.value} />
                                    })
                                }
                                </Select>

                            </label>

                            <label className='selectWrap selectInputWrap' style={{ width: '310px' }}>
                                <Select onChange={this.changeSelect.bind(this, "searchType")} value={this.state.searchType} clearable={true} style={{ width: "192px", marginRight: "10px" }}	>
                                    <Select.Option key="ProductID" label="商品ID" value="ProductID" />
                                    <Select.Option key="ProductSubject" label="商品标题" value="ProductSubject" />
                                </Select>
                                <Input className='inputSkin' id="productTitle" style={{ width: '192px' }} placeholder="请输入内容" />
                            </label>
                            <Button type="primary" onClick={() => this.queryButton(true)}>查询</Button>
                        </div>
                        <div className='mywrap'>
                            <table className="table-style01">
                                <thead>
                                    <tr>
                                        <th style={{ width: "15%" }}>店铺</th>
                                        <th style={{ width: "40%" }}>商品信息</th>
                                        <th style={{ width: "15%" }}>商品图文视频</th>
                                        <th style={{ width: "15%" }}>商品图文状态</th>
                                        <th style={{ width: "15%" }}>操作</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.productImageTextList.map(item =>
                                             <tr>
                                                <td>
                                                    <div className='newPlatformIconWrap'>
                                                        <PlatformName platformType={this.state.currentPlatformType} isHidePatformName={true} />
                                                        <span style={{ marginLeft: '5px' }}>{this.state.currentShopName}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="productShow table-product">
                                                        <div class="productShow-imgWrap">
                                                            <img src={item.Product.ImageUrl} alt="" />
                                                        </div>
                                                        <ul>
                                                            <li title="商品标题">测试商品不要拍-黑色绒布袋厂家批发拉绳束口袋移动电源收纳袋</li>
                                                            <li>商品Id：{item.Product.PlatformId}</li>
                                                            <li className='productShow-status'>
                                                                <div className='productShow-status-left'>
                                                                    <span>库存:15425</span>
                                                                    <span>价格:￥15425</span>
                                                                </div>
                                                                <div className='productShow-status-right'>
                                                                    {
                                                                        item.Product.Status == 'published' ?
                                                                            <span className='tarTxt tarTxt01'>在售</span>:null
                                                                    }
                                                                    {
                                                                        item.Product.Status != 'published' ?
                                                                            <span className='tarTxt tarTxt07'>下架</span>:null
                                                                    }
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td>
                                                    {
                                                        item.ProductImageText && item.ProductImageText  == '2' ?
                                                        <div>
                                                            <span className='iconfont icon-bofang' onClick={()=>{ window.open('https://fxg.jinritemai.com/ffa/creative/graphics-position-bottom') }}></span>
                                                        </div>
                                                        :<div>
                                                            <span className='iconfont icon-wushuju'></span>
                                                        </div>
                                                    }
                                                    {/* <span className='iconfont icon-bofang'></span> */}
                                                </td>
                                                <td>
                                                    {
                                                        item.ProductImageText ?
                                                        item.ProductImageText.ProcessStatus == "1" ?
                                                        <div>
                                                            <i class="dot-ZT" style={{ backgroundColor: "#00cc33" }}></i>
                                                            <span>发布中</span>
                                                        </div>
                                                        :item.ProductImageText.ProcessStatus == "2" ?
                                                        <div>
                                                            <i class="dot-ZT" style={{ backgroundColor: "#027cff" }}></i>
                                                            <span>发布成功</span>
                                                        </div>
                                                        :item.ProductImageText.ProcessStatus == "3" ?
                                                        <div>
                                                            <i class="dot-ZT" style={{ backgroundColor: "#ff0000" }}></i>
                                                            <span>发布失败</span>
                                                            {
                                                                item.ProductImageText.Message ? <span>{item.ProductImageText.Message}</span>:null
                                                            }
                                                        </div>
                                                        :item.ProductImageText.ProcessStatus == "0" ?
                                                        <div>
                                                            <i class="dot-ZT" style={{ backgroundColor: "#e4e4e4" }}></i>
                                                            <span>待发布</span>
                                                        </div>:null
                                                        :<div>
                                                            <i class="dot-ZT" style={{ backgroundColor: "#e4e4e4" }}></i>
                                                            <span>无图文信息</span>
                                                        </div>
                                                    }
                                                    
                                                </td>
                                                <td>
                                                    {
                                                        item.ProductImageText ?
                                                        <div>
                                                            {
                                                                item.ProductImageText.ProcessStatus == "0" || item.ProductImageText.ProcessStatus == "2" || item.ProductImageText.ProcessStatus == "3" ? 
                                                                <span className="defColor hover" style={{ marginRight: "10px" }} onClick={() => this.showReleaseDailog(item)}>编辑</span>:null
                                                            }
                                                            {
                                                                item.ProductImageText.ProcessStatus == "0" || item.ProductImageText.ProcessStatus == "3" ? 
                                                                <span className="defColor hover" style={{ marginRight: "10px" }} 
                                                                onClick={() => this.confirmApply(item)}>去发布</span>:null
                                                            }
                                                        </div>:
                                                        <div>
                                                            <span className="defColor hover" style={{ marginRight: "10px" }} onClick={() => this.showReleaseDailog(item)}>新增图文</span>
                                                        </div>
                                                    }
                                                    {/* <span className="defColor hover" style={{ marginRight: "10px" }} onClick={()=>this.deItem()}>删除</span> */}
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            <div className='paginationwrap'>
                                <Pagination onCurrentChange={this.changeCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.total} pageSize={this.state.pageSize} currentPage={this.state.current} pageSizes={[10, 30, 50]} />
                            </div>
                        </div>
                        {
                            this.state.isShowReleaseDailog ? this.showReleaseProductDailog() : null
                        }
                        {/* {
                            this.showReleaseProductDailog() 
                        } */}
                    </div>
                </main>

                <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} />
            </div>
        );
    }
}

export default ProductImageText;



// WEBPACK FOOTER //
// ./src/pages/productImageText/productImageText.jsx